<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class LoadDataStatusMixin extends Vue {
        loadDataError = false

        showLoadDataStatusMessage() {
            if (this.loadDataError) {
                this.$toast.error(this.$t('error_message.something_went_wrong'))
            }
        }

        get noDataText() {
            return this.loadDataError
                ? `${this.$vuetify.locale.t('$vuetify.noDataText')}. ${this.$t('error_message.load_error')}`
                : this.$vuetify.locale.t('$vuetify.noDataText')
        }
    }

    export default LoadDataStatusMixin
</script>
